import * as zExt from "@redotech/rpc/ext";
import { privacy } from "@redotech/schema-privacy";
import * as z from "zod";

const OMSUserSchema_ = z.object({
  roles: z.array(z.string().meta({ privacy: privacy.enumOrStatus })).nullish(),
  _id: z.string().meta({ privacy: privacy.id.internal }),
  email: z.string().meta({ privacy: privacy.email.merchantUser }),
  createdAt: z.coerce.date().meta({ privacy: privacy.timestamp }),
  firstName: z.string().meta({ privacy: privacy.person_name.merchant }),
  lastName: z.string().meta({ privacy: privacy.person_name.merchant }),
  name: z.string().meta({ privacy: privacy.person_name.merchant }),
  updatedAt: z.coerce.date().meta({ privacy: privacy.timestamp }),
  team: zExt.objectId().meta({ privacy: privacy.id.internal }),
});
export const OMSUserSchema: z.ZodType<OMSUser> = OMSUserSchema_;
export interface OMSUser extends z.infer<typeof OMSUserSchema_> {}
export interface IOMSUser extends z.ZodType<OMSUser> {}

export const unassignedUser: OMSUser = {
  roles: null,
  _id: "unassigned",
  email: "",
  createdAt: new Date(),
  firstName: "Unassigned",
  lastName: "",
  name: "Unassigned",
  updatedAt: new Date(),
  team: "",
};
